import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function House(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 11.762V22H1v2h22v-2h-2V11.762L12 4.56l-9 7.2zM9.5 22h5v-8.72h-5V22z"
  }), React.createElement("path", {
    d: "M2.625 10.062L12 2.56l9.375 7.5a1 1 0 001.25-1.562L19 5.6V1.28h-2V4l-5-4L1.375 8.5a1 1 0 001.25 1.562",
    clipRule: "evenodd"
  }));
}

export { House };
//# sourceMappingURL=House.js.map